import React, { useState } from 'react';
import './App.scss';
import AllRoutes from './routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LogScreen } from './components';

import { LogProvider } from 'src/components/LogProvider';

import { ReactComponent as Bug } from 'src/assets/icons/bug.svg';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  const [openLogScreen, setOpenLogScreen] = useState(false);
  const isLoginScreen =
    location.pathname === '/login' ||
    location.pathname === '/recuperarsenha' ||
    location.pathname === '/' ||
    location.pathname.startsWith('/login/') ||
    location.pathname.startsWith('/recuperarsenha/');

  return (
    <ErrorBoundary>
      <div className="App background">
        <LogProvider>
          <AllRoutes />

          <ToastContainer position="top-right" autoClose={3000} />
          {!isLoginScreen && (
            <>
              <button
                className="logscreenToogle"
                onClick={() => setOpenLogScreen(true)}
              >
                <span>
                  <Bug />
                </span>
              </button>
              {openLogScreen && (
                <LogScreen onClose={() => setOpenLogScreen(false)} />
              )}
            </>
          )}
        </LogProvider>

        <span className="version">Version 0.1.30</span>
      </div>
    </ErrorBoundary>
  );
}

export default App;
